<template>
  <v-card>
    <v-expansion-panel v-model="panel" popout>
      <v-expansion-panel-content
        v-for="(cardPage, i) in cardPages"
        :key="i"
        lazy
      >
        <template v-slot:header>
          <div class="title" v-text="cardPage.pageName" />
        </template>
        <v-card>
          <v-form v-model="cardFormValid" lazy-validation :ref="'cardForm' + i">
            <v-card-text>
              <v-container fluid grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12 sm5>
                    <v-text-field
                      label="Page name"
                      v-model="cardPage.pageName"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field
                      label="Title"
                      v-model="cardPage.title"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Side menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="cardPage.sideMenuLink"
                          restrict="SIDE_MENU"
                          @clearLink="$delete(cardPage, 'sideMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Top menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="cardPage.topMenuLink"
                          restrict="TOP_MENU"
                          @clearLink="$delete(cardPage, 'topMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Bottom menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="cardPage.bottomMenuLink"
                          restrict="BOTTOM_MENU"
                          @clearLink="$delete(cardPage, 'bottomMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Floating button</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7 v-if="cardPage.floatingButton">
                        <v-select
                          v-model="cardPage.floatingButton.floatingType"
                          :items="floatingTypes"
                          label="Floating type"
                          :rules="[formRules.required]"
                        />

                        <v-card class="mb-2">
                          <v-card-text>
                            <v-text-field
                              label="Text"
                              v-model="cardPage.floatingButton.actionItem.text"
                            />
                            <icon-picker
                              v-model="cardPage.floatingButton.actionItem.icon"
                            />
                            <v-layout row wrap>
                              <v-flex xs12 sm4>
                                <ActionType
                                  v-model="
                                    cardPage.floatingButton.actionItem.action
                                      .type
                                  "
                                />
                              </v-flex>
                              <v-flex xs12 sm6>
                                <ActionLink
                                  v-model="
                                    cardPage.floatingButton.actionItem.action
                                      .link
                                  "
                                  :type="
                                    cardPage.floatingButton.actionItem.action
                                      .type
                                  "
                                  @clearLink="
                                    $delete(
                                      cardPage.floatingButton.actionItem.action,
                                      'link'
                                    )
                                  "
                                />
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-checkbox label="Editable" v-model="cardPage.editable" />
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="cardPage.isAuthenticationRequired"
                      label="Is authentication required"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm7
                    v-if="appMap && appMap.items['cardPages/' + cardPage.id]"
                  >
                    <p>Caching strategy</p>
                    <CachingStrategy
                      v-model="
                        appMap.items['cardPages/' + cardPage.id].cachingStrategy
                      "
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex
                        xs12
                        sm4
                        v-for="(cardPageItem, j) of orderedCardPageItems(i)"
                        :key="j"
                      >
                        <v-card>
                          <v-img
                            v-if="cardPageItem.image"
                            :src="cardPageItem.image"
                            aspect-ratio="2.75"
                          />

                          <v-card-title primary-title>
                            <div>
                              <h3
                                class="headline mb-0"
                                v-text="cardPageItem.title"
                              />
                              <span
                                class="grey--text"
                                v-text="cardPageItem.subTitle"
                              />
                            </div>
                          </v-card-title>

                          <v-card-actions>
                            <v-btn
                              flat
                              round
                              icon
                              @click="
                                reorderCardPageItem(
                                  cardPage,
                                  cardPagesItems[i],
                                  cardPageItem,
                                  true
                                )
                              "
                              :disabled="loading"
                              v-if="j > 0"
                            >
                              <v-icon v-text="fa('angle-left')"></v-icon>
                            </v-btn>
                            <v-btn
                              flat
                              round
                              icon
                              @click="
                                reorderCardPageItem(
                                  cardPage,
                                  cardPagesItems[i],
                                  cardPageItem,
                                  false
                                )
                              "
                              :disabled="loading"
                              v-if="j < cardPagesItems[i].length - 1"
                            >
                              <v-icon v-text="fa('angle-right')"></v-icon>
                            </v-btn>
                            <v-btn
                              flat
                              @click="
                                removeCardPageItem(cardPage, cardPageItem)
                              "
                              :disabled="loading"
                              >Remove</v-btn
                            >
                            <v-spacer />
                            <v-btn
                              flat
                              :to="{
                                name: 'card-page-item',
                                params: {
                                  cardPage: cardPage.id,
                                  id: cardPageItem.id
                                }
                              }"
                              :disabled="loading"
                              >Edit</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-btn
                          @click="addCardPageItem(cardPage)"
                          :disabled="loading"
                        >
                          <v-icon v-text="fa('plus')"></v-icon> Add card page
                          item
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="warning"
                flat
                @click="remove(cardPage)"
                :disabled="loading"
                >Remove</v-btn
              >
              <v-spacer />
              <v-btn
                color="primary"
                @click="save(cardPage, i)"
                :disabled="loading"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-actions>
      <v-layout row align-center justify-center wrap>
        <v-flex xs3>
          <v-text-field label="Name" v-model="newCardPageName" />
        </v-flex>
        <v-flex xs3>
          <v-btn
            @click="addCardPage"
            color="primary"
            :disabled="loading || !newCardPageName"
          >
            <v-icon v-text="fa('calendar-day')"></v-icon>
            Add a card page
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";
import { db } from "../../plugins/firebase";
import { appMapSuffix, eventHub, FloatingType } from "../../config/constants";
import CachingStrategy from "../../components/CachingStrategy";
const cardPagesCollection = db.collection("cardPages");

export default {
  name: "CardPagesList",
  components: {
    ActionLink,
    ActionType,
    CachingStrategy
  },
  data: () => ({
    cardFormValid: true,
    newCardPageName: null,
    loading: false,
    cardPages: [],
    cardPagesItems: [],
    panel: null,
    appMap: null
  }),
  watch: {
    "$route.params.language": {
      immediate: true,
      handler(language) {
        this.$bind(
          "cardPages",
          cardPagesCollection.where("language", "==", String(language))
        );
        this.$bind(
          "appMap",
          db.collection("appMaps").doc(language + appMapSuffix)
        );
      }
    },
    async cardPages(cardPages) {
      if (cardPages.length) {
        this.cardPagesItems = await Promise.all(
          cardPages.map(cardPage =>
            cardPagesCollection
              .doc(cardPage.id)
              .collection("items")
              .get()
              .then(results =>
                results.docs.map(doc => ({
                  id: doc.id,
                  ...doc.data()
                }))
              )
          )
        );
        if (this.$route.params.cardPage) {
          this.panel = cardPages.findIndex(
            cardPage => this.$route.params.cardPage === cardPage.id
          );
        }
      }
    },
    panel(value) {
      if (
        !this.$route.params.cardPage ||
        (this.cardPages[value]
          ? this.$route.params.cardPage !== this.cardPages[value].id
          : true)
      ) {
        this.$router.replace({
          params: {
            cardPage: this.cardPages[value] ? this.cardPages[value].id : null
          }
        });
      }
    }
  },
  methods: {
    async addCardPage() {
      this.panel = null;
      this.loading = true;
      try {
        const newCardPage = cardPagesCollection.doc();
        await db.runTransaction(async t => {
          t.set(newCardPage, {
            editable: true,
            language: this.$route.params.language,
            pageName: this.newCardPageName,
            title: this.newCardPageName,
            isAuthenticationRequired: false,
            floatingButton: {
              actionItem: {
                icon: null,
                text: null,
                action: {
                  type: "NONE"
                },
                showCondition: null,
                preferredViewType: null
              },
              floatingType: "CENTER_DOCKED"
            },
            type: "CARD_PAGE"
          }).set(
            this.$firestoreRefs.appMap,
            {
              items: {
                ["cardPages/" + newCardPage.id]: {
                  cachingStrategy: "ON_OPEN",
                  isAuthenticationRequired: false,
                  name: this.newCardPageName,
                  type: "CARD_PAGE",
                  version: 1
                }
              }
            },
            {
              merge: true
            }
          );
        });
        eventHub.$emit("message", "green");
        this.newCardPageName = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async save(cardPage, i) {
      if (!this.$refs["cardForm" + i][0].validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          t.set(cardPagesCollection.doc(cardPage.id), cardPage);
          t.set(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async remove(cardPage) {
      this.loading = true;
      const appMapItem = this.appMap.items["cardPages/" + cardPage.id];
      try {
        await db.runTransaction(async t => {
          t.delete(cardPagesCollection.doc(cardPage.id));
          delete this.appMap.items["cardPages/" + cardPage.id];
          t.update(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        this.appMap.items["cardPages/" + cardPage.id] = appMapItem;
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async addCardPageItem(cardPage) {
      this.loading = true;
      try {
        const cardPageItem = await cardPagesCollection
          .doc(cardPage.id)
          .collection("items")
          .add({
            title: null,
            subTitle: null,
            order:
              this.cardPagesItems[this.cardPages.indexOf(cardPage)].length + 1,
            image: null,
            icon: null,
            actionItems: [],
            tapAction: {
              type: "NONE"
            }
          });
        eventHub.$emit("message", "green");
        this.$router.push({
          name: "card-page-item",
          params: { cardPage: cardPage.id, id: cardPageItem.id }
        });
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
    },
    async reorderCardPageItem(cardPage, cardPageItems, item, up) {
      this.loading = true;
      try {
        const cardPageItemsOrder = cardPageItems
          .filter(
            cardPageItem =>
              cardPageItem === item ||
              cardPageItem.order === item.order + (up ? -1 : 1)
          )
          .map(cardPageItem => {
            let order;
            if (item === cardPageItem) {
              order = cardPageItem.order + (up ? -1 : 1);
            } else {
              order = cardPageItem.order + (up ? 1 : -1);
            }
            return [cardPageItem, order];
          });
        await db.runTransaction(async t =>
          cardPageItemsOrder.forEach(([cardPageItem, order]) =>
            t.update(
              cardPagesCollection
                .doc(cardPage.id)
                .collection("items")
                .doc(cardPageItem.id),
              "order",
              order
            )
          )
        );
        cardPageItemsOrder.forEach(([cardPageItem, order]) => {
          cardPageItem.order = order;
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async removeCardPageItem(cardPage, cardPageItem) {
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.delete(
            cardPagesCollection
              .doc(cardPage.id)
              .collection("items")
              .doc(cardPageItem.id)
          )
        );
        const cardPageItems = this.cardPagesItems[
          this.cardPages.indexOf(cardPage)
        ];
        cardPageItems.splice(cardPageItems.indexOf(cardPageItem), 1);
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    }
  },
  computed: {
    orderedCardPageItems() {
      return index =>
        this.cardPagesItems.length && this.cardPagesItems[index]
          ? [...this.cardPagesItems[index]].sort((a, b) => a.order - b.order)
          : [];
    },
    floatingTypes: () => FloatingType
  }
};
</script>
